export const PRODUCTS = "/products";
export const CREATE_PRODUCT = `${PRODUCTS}/create`;
export const ADDRESSBOOK_PATH = "address-book";
export const ADDRESSBOOK_LIST_PATH = "address-book.addresses";
export const ADDRESSBOOK_GROUPS_PATH = "address-book.groups";
export const ADDRESSBOOK_EXPORTS_PATH = "address-book.exports";
